export class Vaps {
  readonly uuid: string;
  readonly title: string;
  readonly description: string;
  readonly price: number;
  selected = false;

  constructor(data: any) {
    this.uuid = data.uuid;
    this.title = data.title;
    this.description = data.description;
    this.price = data.price;
  }

  static placeholder(): Vaps {
    return new Vaps({uuid: '', title: '', description: '', price: 0});
  }
}
